export const validateEmail = (value: string): boolean => {
  const emailRegex = new RegExp(/^[a-zA-Z0-9._+-]+@[a-zA-Z0-9-]{2,}(?:\.[a-zA-Z]{2,})+$/, 'gm');
  const numbersOnlyRegex = new RegExp(/^(?!^[0-9._+-]+$)[a-zA-Z0-9._+-]+$/, 'gm');

  return !(value === '' || !emailRegex.test(value) || !numbersOnlyRegex.test(value.split('@')[0]));
};
